import { privateInstance } from "../configs";
import { mappers } from "@/mappers";

const baseUrl = "/sales/api";

export const saleApi = {
  async getSales() {
    const res = await privateInstance.get("/sales/api/cl/");
    return res.data.map(x => mappers.mapSales(x));
  },
  async retrieveSale(id) {
    const res = await privateInstance.get(`/sales/api/rud/${id}/`);
    return mappers.mapSales(res.data);
  },
  async postSale(sale) {
    const res = await privateInstance.post(`/sales/api/cl/`, sale);
    return mappers.mapSales(res.data);
  },
  async patchSale(id, sale) {
    const res = await privateInstance.patch(`/sales/api/rud/${id}/`, sale);
    return mappers.mapSales(res.data);
  },
  async putSale(id, sale) {
    const res = await privateInstance.put(`/sales/api/rud/${id}/`, sale);
    return mappers.mapSales(res.data);
  },
  async deleteSale(id) {
    const res = await privateInstance.delete(`/sales/api/rud/${id}/`);
    return res.data;
  },
  async getSalesEstimates() {
    const res = await privateInstance.get(`${baseUrl}/estimate/`);
    return res.data.map(x => mappers.mapSalesEstimates(x));
  },
  async postSaleEstimate(data) {
    const res = await privateInstance.post(`${baseUrl}/estimate/`, data);
    return mappers.mapSalesEstimates(res.data);
  },
  async patchSaleEstimate(id, data) {
    const res = await privateInstance.patch(`${baseUrl}/estimate/${id}/`, data);
    return mappers.mapSalesEstimates(res.data);
  },
  async deleteSaleEstimate(id) {
    const res = await privateInstance.delete(`${baseUrl}/estimate/${id}/`);
    return mappers.mapSalesEstimates(res.data);
  },
  async getSaleOptionalValues() {
    const res = await privateInstance.get(`${baseUrl}/optionalvalue/`);
    return res.data;
  },
  async postSaleOptionalValue(data) {
    const res = await privateInstance.post(`${baseUrl}/optionalvalue/`, data);
    return res.data;
  },
  async patchSaleOptionalValue(id, data) {
    const res = await privateInstance.patch(
      `${baseUrl}/optionalvalue/${id}/`,
      data
    );
    return res.data;
  },
  async deleteSaleOptionalValue(id) {
    const res = await privateInstance.delete(`${baseUrl}/optionalvalue/${id}/`);
    return res.data;
  }
};
